const CountryConfigDefaults = {
    min: 10000,
    max: 500000,
};
export const PAYOUT_ACCOUNTS_LIMIT = 5;
export default CountryConfigDefaults;
